<template lang="pug">
app-modal(
  titulo="Redefinir senha",
  :responsive="true"
  @closeModal="closeModal()",
)
  template(slot="body")
    validation-observer(ref='observer' tag='form')
      div(v-if="isCamposModal", key="cpfCnpj")
        app-label(label="Insira seu CPF/CNPJ")
        form(@keyup.enter="getErro()")
          validation-provider(rules="required|cpf_cnpj", v-slot="{ errors }", name="cpfCnpj" mode="lazy")
            el-input.input(
              :class="{'erro' : errors.length}",
              v-model="cpfCnpj"
              v-mask="['###.###.###-##', '##.###.###/####-##']",
            )
            span.help.erro {{ errors[0] }}
      div(v-else, key="email")
        app-label(label="Insira seu e-mail")
        form(@keyup.enter="getErro()")
          validation-provider(rules="required|email", v-slot="{ errors }", name="email", mode="lazy")
            el-input.input(
              :class="{'erro' : errors.length}",
              v-model="email",
            )
            span.help.erro {{ errors[0] }}
        p.margin-top Email cadastrado: {{ this.emailBuscado }}
  template(slot="footer")
    div.buttons
      el-button(@click="closeModal()") Cancelar
      el-button(
          v-if="isCamposModal",
          @click="buscarEmail()",
          key="botao-proximo"
        ) Próximo
      el-button(
        v-else,
        key="botao-confirma",
        @click="redefinirSenha()"
          ) Confirmar
</template>

<script>
import { mapActions } from 'vuex'
import AppModal from '@/components/AppModal'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  components: {
    AppModal,
    AppLabel
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      email: '',
      isCamposModal: true,
      cpfCnpj: '',
      emailBuscado: ''
    }
  },

  methods: {
    ...mapActions({
      findEmailByCpfCnpj: 'usuario/findEmailByCpfCnpj',
      requestRedefinirSenha: 'usuario/requestRedefinirSenha'
    }),

    closeModal () {
      this.$emit('closeModal')
    },

    async buscarEmail () {
      if (!(await this.$refs.observer.validate())) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS
        )
      } else {
        const result = await this.findEmailByCpfCnpj(this.cpfCnpj)

        this.isCamposModal = false
        this.emailBuscado = result
      }
    },

    async redefinirSenha () {
      if (!(await this.$refs.observer.validate())) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS
        )
        return
      }

      await this.requestRedefinirSenha({
        cpfCnpj: this.cpfCnpj,
        email: this.email}
      )

      this.showNotificacao(
        this.$messages.TIPO_SUCCESS,
        this.$messages.TITULO_SUCCESS,
        this.$messages.MSG_REDEFINIR_SENHA
      )
      this.closeModal()
    }

  }

}
</script>

<style scoped lang="scss">
.buttons {
  display: flex;
  justify-content: space-between;
}

.margin-top {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/seguranca/components/AppModalRedefinirSenha.vue